<template>
  <DxDataGrid
    id="simple-datagrid-custom"
    :data-source="items"
    :show-borders="true"
    :show-column-lines="true"
    :show-row-lines="true"
    :row-alternation-enabled="true"
    :columnAutoWidth="true"
    :allow-column-resizing="true"
  >
  <DxExport :enabled="true" />
    <DxSearchPanel :visible="true" :width="240" placeholder="Buscar..." />
    <DxPaging :page-size="15" />
    <DxPager
      :visible="true"
      infoText="Página {0} de {1} ({2} registros)"
      :allowed-page-sizes="pageSizes"
      display-mode="full"
      :show-page-size-selector="true"
      :show-info="true"
      :show-navigation-buttons="true"
    />
    <DxHeaderFilter :visible="true" />
    <DxFilterRow :visible="true">
      <DxOperationDescriptions
        equal="Igual a"
        notEqual="Diferente de"
        startsWith="Empieza con"
        endsWith="Termina con"
        contains="Contiene"
        between="Entre"
        notContains="No contiene"
        lessThanOrEqual="Menor o igual"
        greaterThanOrEqual="Mayor o igual"
        lessThan="Menor que"
        greaterThan="Mayor que"
      />
    </DxFilterRow>

    <DxColumn
      v-for="(item, i) in headers"
      :key="i"
      :data-field="item.dataField"
      :caption="item.caption"
      :cell-template="item.dataField === 'icon' ? 'icon' : undefined"
      :group-index="hasIndexGroup ? item.group : undefined"
      alignment="center"
    />
    <template #icon="{ data: cellData }">
      <i :class="cellData.data.icon"></i>
    </template>
  </DxDataGrid>
</template>

<script>
import {
  DxDataGrid,
  DxPaging,
  DxColumn,
  DxExport,
  DxSearchPanel,
  DxFilterRow,
  DxHeaderFilter,
  DxPager,
  DxOperationDescriptions,
} from "devextreme-vue/data-grid";
export default {
  components: {
    DxDataGrid,
    DxPaging,
    DxColumn,
    DxExport,
    DxSearchPanel,
    DxOperationDescriptions,
    DxFilterRow,
    DxHeaderFilter,
    DxPager,
  },
  data() {
    return {
      pageSizes: [15, 30, 50],
      texts: {
        editRow: "Editar",
        saveRowChanges: "Guardar",
        saveAllChanges: "Guardar cambios",
        deleteRow: "Eliminar",
        cancelRowChanges: "Cancelar",
        confirmDeleteTitle: "Información",
        confirmDeleteMessage: "¿Realmente desea eliminar el registro?",
        cancelAllChanges: "Descartar cambios",
      },
    };
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    headers: {
      type: Array,
      default: () => [],
    },
    hasIndexGroup: {
      type: Boolean,
      default: () => false,
    }
  },
};
</script>
